<template>
  <section v-if="visible()" class="step-icons row justify-content-between">
    <div class="step text-center font-weight-bold flex-wrap mb-5">
      <img src="@/assets/icons/stepicons-housevisit.svg" />
      <p class="text-primary" v-dynamic-content:confirmation_nextsteps_step1></p>
      <p v-dynamic-content:confirmation_nextsteps_step_housevisit></p>
    </div>
    <div class="step text-center font-weight-bold flex-wrap mb-5">
      <img src="@/assets/icons/stepicons-install-intake.svg" />
      <p class="text-primary" v-dynamic-content:confirmation_nextsteps_step2></p>
      <p v-dynamic-content:confirmation_nextsteps_step_intake></p>
    </div>
    <div class="step text-center font-weight-bold flex-wrap mb-5">
      <img src="@/assets/icons/stepicons-install.svg" />
      <p class="text-primary" v-dynamic-content:confirmation_nextsteps_step3></p>
      <p v-dynamic-content:confirmation_nextsteps_step_installation></p>
    </div>
    <div class="step text-center font-weight-bold flex-wrap mb-5">
      <img src="@/assets/icons/stepicons-arei.svg" />
      <p class="text-primary" v-dynamic-content:confirmation_nextsteps_step4></p>
      <p v-dynamic-content:confirmation_nextsteps_step_arei></p>
    </div>
    <div class="step text-center font-weight-bold flex-wrap mb-5">
      <img src="@/assets/icons/stepicons-enjoy.svg" />
      <p class="text-primary" v-dynamic-content:confirmation_nextsteps_step5></p>
      <p v-dynamic-content:confirmation_nextsteps_step_enjoy></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StepsIcons',
  methods: {
    visible() {
      const stepslist = [
        this.content.confirmation_nextsteps_step1,
        this.content.confirmation_nextsteps_step2,
        this.content.confirmation_nextsteps_step3,
        this.content.confirmation_nextsteps_step4,
        this.content.confirmation_nextsteps_step5,
      ]

      return stepslist.every((s) => s)
    },
  },
}
</script>
